"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDnd = require("react-dnd");

var _flow = _interopRequireDefault(require("lodash/flow"));

var _Tag = _interopRequireDefault(require("./Tag.style"));

var _HoverAccentButton = _interopRequireDefault(require("../Button/HoverAccentButton"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Loader = _interopRequireDefault(require("../Loader"));

var Types = {
  tag: 'tag'
};
var tagSource = {
  beginDrag: function beginDrag(props, monitor, component) {
    // console.log(props);
    // console.log(monitor);
    console.log('From Begin ', props);
    return {
      index: props.tagIndex
    };
  }
};
var tagTarget = {
  hover: function hover(props, monitor, component) {
    var dragIndex = monitor.getItem().index;
    var dropIndex = props.tagIndex;

    if (dragIndex === dropIndex) {
      return;
    }

    var hoverBoundingRect = _reactDom.default.findDOMNode(component).getBoundingClientRect();

    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var clientOffset = monitor.getClientOffset();
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < dropIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    if (dragIndex > dropIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.onDrop(dragIndex, dropIndex);
    monitor.getItem().index = dropIndex; // console.log('From Hover  ' +dropIndex)
  },
  drop: function drop(props, monitor) {
    var dragIndex = monitor.getItem().index;
    var dropIndex = props.tagIndex; // if (dropIndex === dragIndex) { return; }

    props.onDrop(dragIndex, dropIndex, true);
    monitor.getItem().index = dropIndex;
    console.log('from Drop ' + dropIndex);
  }
};

var Tag =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Tag, _React$PureComponent);

  function Tag() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tag)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "clickHandler", function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          id = _this$props.id;
      if (onClick && !disabled) onClick(id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "closeClickHandler", function (event) {
      event.stopPropagation();
      var _this$props2 = _this.props,
          onCloseClick = _this$props2.onCloseClick,
          id = _this$props2.id;
      if (onCloseClick) onCloseClick(id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "calculateMarginLeft", function (size) {
      return size === 'large' ? '24px' : size === 'regular' ? '16px' : '10px';
    });
    return _this;
  }

  (0, _createClass2.default)(Tag, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          children = _this$props3.children,
          className = _this$props3.className,
          size = _this$props3.size,
          disabled = _this$props3.disabled,
          canClose = _this$props3.canClose,
          showLoader = _this$props3.showLoader,
          connectDragSource = _this$props3.connectDragSource,
          connectDropTarget = _this$props3.connectDropTarget,
          connectDragPreview = _this$props3.connectDragPreview,
          isDragging = _this$props3.isDragging,
          draggable = _this$props3.draggable;

      var tag = _react.default.createElement(_Tag.default, {
        className: (0, _classnames.default)('Tag', className),
        role: "button",
        tabIndex: 0,
        onClick: this.clickHandler,
        canClose: canClose,
        disabled: disabled,
        size: size
      }, value || children, canClose && _react.default.createElement(_HoverAccentButton.default, {
        onClick: this.closeClickHandler,
        disabled: disabled,
        iconFillName: "black3",
        style: {
          height: 'auto',
          width: 'auto',
          marginLeft: this.calculateMarginLeft(size)
        }
      }, !showLoader ? _react.default.createElement(_Icon.default, {
        type: "close",
        style: {
          width: '12px',
          height: '12px'
        }
      }) : _react.default.createElement(_Loader.default, {
        style: {
          marginLeft: '6px'
        },
        width: 16,
        height: 16
      })));

      if (draggable) {
        return connectDragPreview(connectDragSource(connectDropTarget(_react.default.createElement("div", null, tag))));
      }

      return tag;
    }
  }]);
  return Tag;
}(_react.default.PureComponent);

Tag.propTypes = {
  id: _propTypes.default.string,
  value: _propTypes.default.string,
  size: _propTypes.default.oneOf(['regular', 'large']),
  disabled: _propTypes.default.bool,
  canClose: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onCloseClick: _propTypes.default.func
};
Tag.defaultProps = {
  id: undefined,
  value: undefined,
  size: 'regular',
  disabled: false,
  canClose: false,
  onClick: undefined,
  onCloseClick: undefined
}; // export default Tag;

var _default = (0, _flow.default)((0, _reactDnd.DragSource)(Types.tag, tagSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}), (0, _reactDnd.DropTarget)(Types.tag, tagTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    hovered: monitor.isOver()
  };
}))(Tag);

exports.default = _default;